import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "imageWithCaption",
  type: "image",
  title: "Image",
  options: {
    hotspot: true
  },
  fields: [
    {
      name: "alt",
      type: "multilingualArrayString",
      title: "Alternative text",
      description: "Important for SEO and accessibility.",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "caption",
      type: "multilingualArrayString",
      title: "Caption",
      options: {
        collapsible: true,
        collapsed: true
      }
    }
  ],
  preview: {
    select: {
      imageUrl: "asset.url",
      title: "caption"
    },
    prepare({ imageUrl, title }) {
      return {
        imageUrl,
        title: multilingualStringPreview(title)
      };
    }
  }
});
